var priorityCss = [
    // file names of CSS to skip lazyloading
    'theme.css',
    'tailwind.css',
    'okendo-reviews.css',
    'custom.scss.css',
    'currency-flags.css',
    'https://use.typekit.net/nik7njq.css',
  ],
  priorityJs = [
    // file names of JS to skip lazyloading
    'https://code.jquery.com/jquery-3.6.0.min.js',
    'https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css',
    'preload.js',
    'unload.js',
    'https://ls-registry-wishlist.gadget.app/api/client/web.min.js',
    'https://ls-registry-wishlist--development.gadget.app/api/client/web.min.js',
    'https://s.axon.ai/s/pixel.js',
    'https://c.albss.com/p/l/loader.iife.js',
    'https://c.albss.com/p/100/b/bs.f899139df5e1059396431415e770c6dd-1.iife.js',
    'https://c.albss.com/p/100/hs/hs.iife.js',
    'https://c.hrzn-nxt.com/js/v2.12.0/connect.min.js',
    'https://assets.rch.io/d6dd2a52-3475-4f69-9edb-78bd87f992e2/localize.js',
    'https://dev.visualwebsiteoptimizer.com',
    'https://evdni.littlesleepies.com/load',
    'https://evdni.littlesleepies.com/providers/honeycomb/load',
    'https://static.userback.io/widget/v1.js',
    'https://api.consentjs.datagrail.io/consent/510a35d9-107b-45e3-a1e0-2d58648ef64e/d0e78a41-c414-4afb-bdcc-09938fc9d430/consent.js',
  ]

;(function preloadJS() {
  function lazyIframe(e) {
    e.setAttribute('loading', 'lazy')
    e.src && e.setAttribute('data-src', e.src)
    e.removeAttribute('src')
  }

  function lazyVideo(e) {
    if (e.src) {
      e.src && e.setAttribute('data-src', e.src), e.removeAttribute('src')
    } else if (e.innerHTML) {
      e.dataset.html = e.innerHTML
      e.innerHTML = ''
    }
  }

  function lazyJS(e) {
    if (e.src.includes('algolia') || e.src.includes('instantsearch')) {
      return
    } else if (e.innerHTML.includes('asyncLoad')) {
      // AsyncLoad
      e.innerHTML = e.innerHTML
        .replace(
          'if(window.attachEvent)',
          "document.addEventListener('asyncLazyLoad',function(event){asyncLoad();});if(window.attachEvent)"
        )
        .replaceAll(', asyncLoad', ', function(){}')
    } else if (e.innerHTML.includes('PreviewBarInjector') || e.innerHTML.includes('adminBarInjector')) {
      // previewBar
      e.innerHTML = e.innerHTML.replace('DOMContentLoaded', 'loadBarInjector')
    } else if (e.type !== 'text/plain') {
      let hasPriority = priorityJs.find((t) => e.src.includes(t))
      !hasPriority &&
        (e.setAttribute('data-src', e.src),
        e.removeAttribute('src'),
        (e.dataset.type = e.type),
        (e.type = 'text/lazyload'))
    } else if (e.src) {
      e.setAttribute('data-src', e.src)
      e.removeAttribute('src')
      e.dataset.type = e.type
      e.type = 'text/lazyload'
    } else {
      e.dataset.type = e.type
      e.type = 'text/lazyload'
    }
  }

  function hasPriority(e) {
    return e.hasAttribute('data-load-priority')
  }

  ;(function init() {
    window.uLTS = new MutationObserver((mutationRec) => {
      mutationRec.forEach(({ addedNodes }) => {
        addedNodes.forEach((node) => {
          1 === node.nodeType && 'IFRAME' === node.tagName && !hasPriority(node) && lazyIframe(node),
            1 === node.nodeType && 'VIDEO' === node.tagName && !hasPriority(node) && lazyVideo(node),
            1 === node.nodeType && 'SCRIPT' === node.tagName && !hasPriority(node) && lazyJS(node)
        })
      })
    })

    window.uLTS.observe(document.documentElement, { childList: !0, subtree: !0 })
  })()
})()

// var priorityCss = [
//     // file names of CSS to skip lazyloading
//     'tailwind.css',
//     'currency-flags.css',
//     'https://use.typekit.net/nik7njq.css',
//   ],
//   priorityJs = [
//     // file names of JS to skip lazyloading
//     'https://code.jquery.com/jquery-3.6.0.min.js',
//     'preload.js',
//     'unload.js',
//     'https://dev.visualwebsiteoptimizer.com',
//     'https://cdn.cookielaw.org/consent/f8574d2c-fe5f-4da6-a9d0-e7706f33dc3c/OtAutoBlock.js',
//     'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
//     'https://ls-registry-wishlist.gadget.app/api/client/web.min.js',
//     'https://assets.rch.io/d6dd2a52-3475-4f69-9edb-78bd87f992e2/localize.js',
//     'https://shopify-init.blackcrow.ai/js/core/little-sleepies.js?shopify_app_version=1.0.242&shop=little-sleepies.myshopify.com',
//     'https://static.userback.io/widget/v1.js',
//   ]

// window.___mnag = 'userA' + (window.___mnag1 || '') + 'gent'
// window.___plt = 'plat' + (window.___mnag1 || '') + 'form'
// try {
//   var a = navigator[window.___mnag],
//     e = navigator[window.___plt]
//   ;(window.__isPSA = e.indexOf('x86_64') > -1 && a.indexOf('CrOS') < 0), (window.___mnag = '!1'), (c = null)
// } catch (d) {
//   window.__isPSA = !1
//   window.___mnag = '!1'
// }

// window.__isPSA = __isPSA

// const lazyIframe = (e) => {
//   e.setAttribute('loading', 'lazy')
//   e.src && e.setAttribute('data-src', e.src)
//   e.removeAttribute('src')
// }

// const lazyVideo = (e) => {
//   if (e.src) {
//     e.src && e.setAttribute('data-src', e.src), e.removeAttribute('src')
//   } else if (e.innerHTML) {
//     e.dataset.html = e.innerHTML
//     e.innerHTML = ''
//   }
// }

// const lazyJS = (e) => {
//   if (e.id === 'oneTrust' || e.id === 'vwoCode' || e.id === 'userbackScript') {
//     return
//   } else if (e.innerHTML.includes('asyncLoad')) {
//     // AsyncLoad
//     e.innerHTML = e.innerHTML
//       .replace(
//         'if(window.attachEvent)',
//         "document.addEventListener('asyncLazyLoad',function(event){asyncLoad();});if(window.attachEvent)"
//       )
//       .replaceAll(', asyncLoad', ', function(){}')
//   } else if (e.innerHTML.includes('PreviewBarInjector') || e.innerHTML.includes('adminBarInjector')) {
//     // previewBar
//     e.innerHTML = e.innerHTML.replace('DOMContentLoaded', 'loadBarInjector')
//   } else if (e.type !== 'text/plain') {
//     let hasPriority = priorityJs.find((t) => e.src.includes(t))
//     !hasPriority &&
//       (e.setAttribute('data-src', e.src),
//       e.removeAttribute('src'),
//       (e.dataset.type = e.type),
//       (e.type = 'text/lazyload'))
//   }
// }

// var uLTS = new MutationObserver((e) => {
//   e.forEach(({ addedNodes: e }) => {
//     e.forEach((e) => {
//       1 === e.nodeType && 'IFRAME' === e.tagName && lazyIframe(e),
//         1 === e.nodeType && 'VIDEO' === e.tagName && lazyVideo(e),
//         1 === e.nodeType && 'SCRIPT' === e.tagName && lazyJS(e)
//     })
//   })
// })

// uLTS.observe(document.documentElement, { childList: !0, subtree: !0 })
